import { styled } from 'baseui'
import type { Theme } from 'baseui'
import { pulseLighting } from '@/shared/theme/pulseLighting'

interface ThemeProps {
  $theme: Theme
}

export const PulseSubhead = styled('p', ({ $theme }: ThemeProps) => ({
  marginTop: '4px',
  marginBottom: '12px',
  marginLeft: 0,
  marginRight: 0,
  fontSize: '14px',
  lineHeight: '20px',
  fontWeight: 600,
  color: $theme.colors.textPulseStrong,
}))

// Tooltips rendered from outside a PulseScope (the tab row) don't get the PULSE theme, so the light look is explicit.
export const pulseTooltipOverrides = {
  Body: {
    style: ({ $theme }: ThemeProps) => ({
      backgroundColor: $theme.colors.white,
      borderTopLeftRadius: '8px',
      borderTopRightRadius: '8px',
      borderBottomLeftRadius: '8px',
      borderBottomRightRadius: '8px',
      boxShadow: pulseLighting($theme).shadowPulsePopover,
    }),
  },
  Inner: {
    style: ({ $theme }: ThemeProps) => ({
      backgroundColor: $theme.colors.white,
      color: $theme.colors.textPulseStrong,
      maxWidth: '240px',
      paddingTop: '7px',
      paddingBottom: '7px',
      paddingLeft: '10px',
      paddingRight: '10px',
      fontSize: '12px',
      lineHeight: '17px',
      borderTopWidth: '1px',
      borderBottomWidth: '1px',
      borderLeftWidth: '1px',
      borderRightWidth: '1px',
      borderTopStyle: 'solid',
      borderBottomStyle: 'solid',
      borderLeftStyle: 'solid',
      borderRightStyle: 'solid',
      borderTopColor: $theme.colors.borderPulse,
      borderBottomColor: $theme.colors.borderPulse,
      borderLeftColor: $theme.colors.borderPulse,
      borderRightColor: $theme.colors.borderPulse,
      borderTopLeftRadius: '8px',
      borderTopRightRadius: '8px',
      borderBottomLeftRadius: '8px',
      borderBottomRightRadius: '8px',
    }),
  },
  Arrow: {
    style: ({ $theme }: ThemeProps) => ({
      backgroundColor: $theme.colors.white,
    }),
  },
}

export const pulseWideModalOverrides = {
  Dialog: {
    style: ({ $theme }: ThemeProps) => ({
      width: '60vw',
      maxWidth: '860px',
      display: 'flex',
      flexDirection: 'column' as const,
      borderTopLeftRadius: '12px',
      borderTopRightRadius: '12px',
      borderBottomRightRadius: '12px',
      borderBottomLeftRadius: '12px',
      backgroundColor: $theme.colors.white,
      boxShadow: pulseLighting($theme).shadowPulseModal,
    }),
  },
}

export const pulseModalHeaderStyle = ({ $theme }: ThemeProps) => ({
  fontSize: '18px',
  lineHeight: '24px',
  fontWeight: 600,
  color: $theme.colors.textPulseStrong,
})
